export default __webpack_public_path__ + "static/media/K420_24A420A.8713e68c.STEP";